module.exports = __webpack_public_path__ + "static/media/67.f3ad04f9.jpg";